// Included as raw source by storefront-view.server.ts. No template-literal regex escaping.
function startSoundtrack(config, t) {
  const root = document.getElementById(config.rootId);
  if (!root) return;
  if(config.personal&&window.TripleCPersistentRadio)window.TripleCPersistentRadio.attach(root);
  const status = root.querySelector('[data-soundtrack-status]');
  const feedbackStatus = root.querySelector('[data-soundtrack-feedback-status]');
  const nextButton = root.querySelector('[data-soundtrack-next]');
  const likeButton = root.querySelector('[data-soundtrack-like]');
  const dislikeButton = root.querySelector('[data-soundtrack-dislike]');
  const historyBox = root.querySelector('[data-soundtrack-ratings]');
  const nowPlaying = root.querySelector('[data-soundtrack-title]');
  const say = text => { status.textContent = text; };
  const tell = text => { feedbackStatus.textContent = text; };
  const displayTitle = value => { const el = document.createElement('textarea'); el.innerHTML = String(value || ''); return el.value; };
  const identity = item => t.identity(item, config.artists || []);
  let playerFrame, emptyPlayerNote;
  let stopped=false;
  let player, index = 0, refillPromise, advancePromise, feedbackReady = false, feedbackBusy = false;
  let continuationError = '';
  let ratings = [], scope = 'unavailable', token = null, revision = 0, batch = 0, nextRefillAt = 0, errorCount = 0, ready = false;
  let activity = {count:0,recent:[],tracks:[]}, playRecorded = false, playWrites = Promise.resolve(), likedQuery = '';
  const activityKey = 'triplec:soundtrack:activity:v13';
  const guestKey = 'triplec:soundtrack:guest:v12';
  const played = new Set(), seen = new Set(), failed = new Set();
  const savedKeys = new Set();
  const saved = config.items.filter(item => {
    const key = identity(item).key;
    if (savedKeys.has(key)) return false;
    savedKeys.add(key); return true;
  }).map(item => ({ ...item, artistName: identity(item).artist, saved: true }));
  const items = saved.slice();
  const current = () => items[index];
  const disliked = item => t.ratingFor(item, ratings)?.vote === 'dislike';
  const available = item => item && !disliked(item) && !failed.has(item.videoId) && (item.manualOnce || item.lane !== 'liked' || t.replayDue(t.ratingFor(item,ratings),activity.count));
  const updateButtons = () => {
    const vote = current() ? t.ratingFor(current(), ratings)?.vote : null;
    likeButton.setAttribute('aria-pressed', String(vote === 'like'));
    dislikeButton.setAttribute('aria-pressed', String(vote === 'dislike'));
    likeButton.textContent = vote === 'like' ? '♥ Liked' : '♡ Like';
    dislikeButton.textContent = vote === 'dislike' ? '👎 Disliked' : '👎 Dislike';
    likeButton.disabled = dislikeButton.disabled = !feedbackReady || feedbackBusy || !current();
    if (nowPlaying) nowPlaying.textContent = displayTitle(current()?.title || 'Choose your soundtrack');
    root.dispatchEvent(new CustomEvent('triplec:track', {detail:current() || null}));
  };
  const renderRatings = () => {
    root.dispatchEvent(new CustomEvent('triplec:ratings', {detail:ratings}));
    historyBox.replaceChildren();
    for (const rating of ratings.slice(-50).reverse()) {
      const row = document.createElement('div');
      const label = document.createElement('span');
      label.textContent = (rating.vote === 'like' ? '♥ ' : '👎 ') + displayTitle(rating.title) + ' ';
      const undo = document.createElement('button');
      undo.type = 'button'; undo.className = 'btn'; undo.textContent = 'Undo';
      undo.disabled = feedbackBusy;
      undo.setAttribute('aria-label', 'Undo ' + rating.vote + ' for ' + rating.title);
      undo.addEventListener('click', () => vote(rating, 'remove'));
      row.append(label, undo); historyBox.append(row);
    }
    if (!ratings.length) historyBox.textContent = 'Your likes and dislikes will appear here.';
    const likedBox = root.querySelector('[data-soundtrack-liked]');
    if (likedBox) {
      likedBox.replaceChildren();
      const likes = ratings.filter(x => x.vote === 'like');
      const count = root.querySelector('[data-soundtrack-liked-count]');
      if (count) count.textContent = String(likes.length);
      const needle = t.norm(likedQuery);
      const filtered = needle ? likes.filter(x => t.norm((x.artist || '') + ' ' + x.title).includes(needle)) : likes;
      for (const rating of filtered.slice().reverse().slice(0,12)) {
        const row = document.createElement('div'), button = document.createElement('button'), remove = document.createElement('button');
        button.type = remove.type = 'button'; button.className = remove.className = 'btn tc-btn';
        button.textContent = '▶ ' + displayTitle(rating.title); button.disabled = !ready;
        button.addEventListener('click', () => playChosen(rating, config.personal ? likes : []));
        remove.textContent = 'Remove'; remove.disabled = feedbackBusy;
        remove.setAttribute('aria-label', 'Remove ' + rating.title + ' from Liked Songs');
        remove.addEventListener('click', () => vote(rating, 'remove'));
        row.append(button,remove); likedBox.append(row);
      }
      if (!likes.length) likedBox.textContent = 'Like a song to save it here.';
      else if (!filtered.length) likedBox.textContent = 'No liked songs match that search.';
      else if (filtered.length > 12) {
        const more = document.createElement('p'); more.className = 'sf-fine'; more.textContent = 'Showing 12 of ' + filtered.length + ' matches. Refine the search to narrow the list.'; likedBox.append(more);
      }
    }
  };
  async function responseJson(res) {
    if (!res.headers.get('content-type')?.includes('application/json')) throw new Error('BAD_RESPONSE');
    const body = await res.json();
    if (!res.ok || body.ok === false) { console.warn('[Triple C soundtrack]',body.error || 'REQUEST_FAILED',body.diagnostics || {}); throw new Error(body.error || 'REQUEST_FAILED'); }
    return body;
  }
  async function fetchFeedback() {
    const body = await responseJson(await fetch('/apps/triple-c/soundtrack/feedback', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(12000) }));
    if (!['account','browser'].includes(body.scope)) throw new Error('UNKNOWN_SCOPE');
    scope = body.scope; token = body.token;
    if (scope === 'account') { ratings = t.normalizeRatings(body.ratings); activity = body.activity || activity; }
    else {
      try { ratings = t.normalizeRatings(JSON.parse(localStorage.getItem(guestKey) || '[]')); activity = JSON.parse(localStorage.getItem(activityKey) || 'null') || activity; }
      catch { ratings = []; }
    }
    feedbackReady = true;
    tell(scope === 'account' ? 'Music preferences saved to your account.' : 'Music preferences saved in this browser.');
    updateButtons(); renderRatings();
  }
  const feedbackLoad = fetchFeedback().catch(() => {
    // Do not mix another person's guest preferences into an unknown signed-in session.
    tell('Preferences could not load. Reload to enable likes and dislikes.');
    updateButtons();
  });
  async function vote(item, value) {
    if (!feedbackReady || feedbackBusy || !item) return;
    feedbackBusy = true; updateButtons(); renderRatings();
    await playWrites;
    const atClick = item.videoId;
    const rich = { ...item, artistName: identity(item).artist, explicitlyRequested: Boolean(item.manualOnce || item.explicitlyRequested) };
    try {
      if (scope === 'account') {
        const send = () => fetch('/apps/triple-c/soundtrack/feedback', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ item: rich, vote: value, token }), signal: AbortSignal.timeout(12000) });
        let res = await send();
        if (res.status === 403) { await fetchFeedback(); res = await send(); }
        const body = await responseJson(res); ratings = t.normalizeRatings(body.ratings); token = body.token;
      } else {
        // Merge the latest browser value so another tab's votes are preserved.
        let previous = ratings;
        try { previous = t.normalizeRatings(JSON.parse(localStorage.getItem(guestKey) || '[]')); } catch { /* surface save failure below */ }
        const next = previous.filter(x => x.key !== identity(rich).key && x.videoId !== rich.videoId);
        if (value !== 'remove') next.push({ ...rich, vote: value });
        const changed = next.find(x => x.videoId === rich.videoId);
        if (changed) { changed.likedAt = Date.now(); changed.lastPlayedCount = activity.count; }
        const clean = t.normalizeRatings(next);
        localStorage.setItem(guestKey, JSON.stringify(clean));
        ratings = clean;
      }
      revision++;
      // Drop speculative automatic tracks; they were selected using old feedback.
      items.splice(index + 1, items.length, ...items.slice(index + 1).filter(x => available(x) && (config.personal ? true : x.saved)));
      nextRefillAt = 0;
      tell(value === 'remove' ? 'Preference removed.' : (value === 'like' ? 'Liked. We’ll favor more music like this.' : 'Disliked. This song is blocked; the artist stays in your taste profile.') + (scope === 'account' ? ' Saved to your account.' : ' Saved in this browser.'));
      if (value === 'dislike' && current()?.videoId === atClick) { player?.stopVideo(); await advance(); }
      else maybePrefetch();
    } catch {
      tell('Could not save that preference. Please try again.');
    } finally { feedbackBusy = false; updateButtons(); renderRatings(); }
  }
  likeButton.addEventListener('click', () => vote(current(), t.ratingFor(current(), ratings)?.vote === 'like' ? 'remove' : 'like'));
  dislikeButton.addEventListener('click', () => vote(current(), t.ratingFor(current(), ratings)?.vote === 'dislike' ? 'remove' : 'dislike'));
  function remember(item) {
    played.add(identity(item).key); seen.add(item.videoId);
    // Bounded rolling session history, separate from persistent feedback.
    while (played.size > 200) played.delete(played.values().next().value);
    while (seen.size > 200) seen.delete(seen.values().next().value);
  }
  function playChosen(item, playlist = []) {
    if (!ready) return;
    if(disliked(item)){say("This song is disliked. Undo the dislike to play it.");return;}
    revision++;
    const chosen = {...item, artistName: identity(item).artist, manualOnce:true};
    if (config.personal) {
      const at = playlist.findIndex(x => x.videoId === item.videoId);
      const rest = at >= 0 ? [...playlist.slice(at+1), ...playlist.slice(0,at)] : [];
      items.splice(0, items.length, chosen, ...rest.map(x => ({...x, artistName:identity(x).artist})));
      index = -1; loadAt(0);
    } else {
      const savedAhead = items.slice(index + 1).filter(x => x.saved && available(x));
      items.splice(index + 1, items.length, chosen, ...savedAhead); nextRefillAt = 0; loadAt(index + 1);
    }
  }
  root.addEventListener('triplec:pause',()=>player?.pauseVideo());
  root.addEventListener('triplec:stop',()=>{stopped=true;player?.stopVideo();player?.destroy?.();});
  root.addEventListener('triplec:play', event => playChosen(event.detail.track, event.detail.tracks));
  root.querySelector('[data-personal-autoplay]')?.addEventListener('change',event=>{config.endBehavior=event.target.checked?'SIMILAR':'STOP';});
  root.querySelector('[data-personal-mix]')?.addEventListener('click',async()=>{
    if(!ready)return;config.endBehavior='SIMILAR';const toggle=root.querySelector('[data-personal-autoplay]');if(toggle)toggle.checked=true;
    say('Building your personal mix…');revision++;player?.pauseVideo();seen.clear();played.clear();items.splice(0,items.length);index=-1;await advance();
  });
  root.addEventListener('triplec:unlike', event => vote(event.detail, 'remove'));
  const toggleButton = root.querySelector('[data-soundtrack-toggle]');
  toggleButton?.addEventListener('click', () => { if (!ready || !current()) return; if (player.getPlayerState() === 1) player.pauseVideo(); else player.playVideo(); });
  const likedSearch = root.querySelector('[data-soundtrack-liked-search]');
  likedSearch?.addEventListener('input', event => { likedQuery = String(event.target?.value || '').slice(0,120); renderRatings(); });
  const searchForm = root.querySelector('[data-soundtrack-search]');
  searchForm?.addEventListener('submit', async event => {
    event.preventDefault();
    const box = root.querySelector('[data-soundtrack-results]');
    box.textContent = 'Searching…';
    const q = new FormData(searchForm).get('q');
    try {
      const body = await responseJson(await fetch('/apps/triple-c/soundtrack/search?' + new URLSearchParams({q:String(q || ''),slug:config.slug || ''}), {credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(30000)}));
      box.replaceChildren();
      for (const item of body.results || []) {
        if(disliked(item))continue;
        const row = document.createElement('div'), button = document.createElement('button');
        button.type = 'button'; button.className = 'btn tc-btn';
        button.textContent = (disliked(item) ? 'Play once (stays disliked): ' : 'Play: ') + displayTitle(item.title);
        button.addEventListener('click', () => playChosen(item, body.results || []));
        row.append(button); box.append(row);
      }
      if (!box.childNodes.length) box.textContent = body.message || (body.discoveryUnavailable ? 'That song is not in the Triple C catalog yet, and new YouTube discovery is temporarily at its daily limit. Try again after the daily refresh.' : 'No results found.');
    } catch { box.textContent = 'Search is unavailable. Try again.'; }
  });
  function recordPlaying() {
    if (playRecorded || !current()) return;
    playRecorded = true;
    const item = {...current(), artistName:identity(current()).artist};
    remember(item);
    activity.count++;
    activity.tracks = [...(activity.tracks || []).filter(x => x.key !== identity(item).key), {key:identity(item).key,videoId:item.videoId}].slice(-200);
    activity.recent = [...(activity.recent || []), {artistName:item.artistName,lane:item.lane || 'anchor'}].slice(-9);
    const rated = t.ratingFor(item,ratings);
    if (rated) { rated.lastPlayedAt = Date.now(); rated.lastPlayedCount = activity.count; }
    const eventId = 'play_' + Date.now() + '_' + Math.random().toString(36).slice(2);
    playWrites = playWrites.then(async () => {
      try {
        if (scope === 'account') {
          const send = () => fetch('/apps/triple-c/soundtrack/feedback', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({event:'played',eventId,item,token,lane:item.lane || 'anchor'}),signal:AbortSignal.timeout(12000)});
          let res = await send();
          if (res.status === 403) { await fetchFeedback(); res = await send(); }
          const body = await responseJson(res); activity = body.activity; token = body.token;
        } else if (scope === 'browser') {
          localStorage.setItem(activityKey,JSON.stringify(activity)); localStorage.setItem(guestKey,JSON.stringify(ratings));
        }
      } catch { tell('Play history could not sync. Liked-song repeats may be delayed.'); }
    });
  }
  const remaining = () => items.slice(index + 1).filter(available).length;
  function maybePrefetch() {
    if (!stopped && config.endBehavior === 'SIMILAR' && remaining() <= 5 && !refillPromise && Date.now() >= nextRefillAt) void extendSimilar();
  }
  function loadAt(next) {
    const item = items[next];
    if (stopped || !available(item) || !player || document.hidden) return false;
    if (playerFrame) playerFrame.hidden = false; if (emptyPlayerNote) emptyPlayerNote.hidden = true;
    index = next; remember(item); playRecorded = false; player.loadVideoById(item.videoId);
    updateButtons(); say(item.saved ? 'Playing your saved soundtrack.' : 'Playing a personalized pick from your soundtrack.');
    // Prune consumed queue while retaining the independent duplicate history.
    if (index > 50) { items.splice(0, index); index = 0; }
    setTimeout(maybePrefetch, 150); return true;
  }
  async function extendSimilar() {
    if (refillPromise) return refillPromise;
    const generation = revision;
    refillPromise = (async () => {
      await feedbackLoad;
      await playWrites;
      const queued = items.slice(index + 1);
      try {
        const body = await responseJson(await fetch('/apps/triple-c/soundtrack/continue', {
          method: 'POST', credentials: 'same-origin', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, signal: AbortSignal.timeout(85000),
          body: JSON.stringify({ personal:config.personal===true, slug: config.slug, batch: batch++, currentVideoId: current()?.videoId || '', exclude: [...seen].filter(id => !t.replayDue(ratings.find(x => x.videoId === id),activity.count)).concat([current()?.videoId, ...queued.map(x => x.videoId)]).filter(Boolean).slice(-200), history: [...played, ...queued.map(x => identity(x).key)].slice(-200), recentArtist: identity(current()).artist, ratings: scope === 'browser' ? ratings : [], count:activity.count, tracks:activity.tracks || [], recent:[...(activity.recent || []), ...(!playRecorded && current() ? [{artistName:identity(current()).artist,lane:current().lane || 'anchor'}] : []), ...queued.map(x => ({artistName:identity(x).artist,lane:x.lane || 'anchor'}))].slice(-9) })
        }));
        if (generation !== revision) return false;
        continuationError = body.discoveryUnavailable && !body.results?.length ? 'YOUTUBE_QUOTA_LIMIT' : '';
        if (body.playbackFallback === 'personalized-known-catalog' && body.results?.length) say('YouTube discovery is paused; continuing with personalized music already known to Triple C.');
        if (!body.results?.length) console.warn('[Triple C soundtrack] Empty continuation',body.diagnostics || {});
        const known = new Set([...played]);
        const pendingKeys = new Set(items.slice(Math.max(0,index)).map(x => identity(x).key));
        let added = 0;
        for (const item of Array.isArray(body.results) ? body.results : []) {
          const key = identity(item).key;
          if (!/^[\w-]{6,20}$/.test(String(item.videoId || '')) || !available(item) || pendingKeys.has(key) || ((known.has(key) || seen.has(item.videoId)) && !(item.lane === 'liked' && t.replayDue(t.ratingFor(item,ratings),activity.count)))) continue;
          items.push(item); known.add(key); pendingKeys.add(key); added++;
          if (added >= 18) break;
        }
        if (!added) nextRefillAt = Date.now() + 20000;
        return added > 0;
      } catch (error) { continuationError = error?.message || 'REQUEST_FAILED'; nextRefillAt = Date.now() + 60000; return false; }
    })().finally(() => { refillPromise = null; });
    return refillPromise;
  }
  async function advanceRun() {
    nextButton.disabled = true;
    try {
      let next = items.findIndex((x, i) => i > index && available(x));
      if (next >= 0) { loadAt(next); return; }
      if (config.endBehavior === 'REPEAT') {
        const repeat = saved.filter(available);
        if (repeat.length) { items.splice(0, items.length, ...repeat); index = -1; loadAt(0); return; }
        say('All saved songs are disliked or unavailable. Undo a dislike below to restore one.'); return;
      }
      if (config.endBehavior === 'SIMILAR') {
        say('Finding more music connected to this soundtrack…');
        for (let attempt = 0; attempt < 2; attempt++) {
          await extendSimilar();
          if (continuationError) break;
          next = items.findIndex((x, i) => i > index && available(x));
          if (next >= 0) { loadAt(next); return; }
        }
        say(continuationError === 'YOUTUBE_QUOTA_LIMIT' ? 'YouTube discovery is paused for today. Triple C will keep using personalized music already in the shared catalog as it becomes available.' : continuationError ? 'Similar music could not load from YouTube. Please try again shortly.' : 'No fresh matching songs are available right now. Try Skip again shortly.'); return;
      }
      say('Your saved soundtrack has finished.');
    } finally { nextButton.disabled = false; }
  }
  function advance() {
    if (stopped || !ready) return Promise.resolve();
    if (advancePromise) return advancePromise;
    advancePromise = advanceRun().finally(() => { advancePromise = null; });
    return advancePromise;
  }
  nextButton.addEventListener('click', () => { errorCount = 0; void advance(); });
  nextButton.disabled = true; updateButtons();
  async function init() {
    if (player || !window.YT?.Player) return;
    await feedbackLoad;
    if (player) return;
    if (!feedbackReady) { say('Preferences could not load. Reload before playing so your blocked songs stay blocked.'); return; }
    const first = items.findIndex(available);
    index = first >= 0 ? first : -1;
    // Create the identified iframe before its first network request. YouTube
    // error 153 is a session identity failure, not a failed song.
    const mount = document.getElementById(config.playerId);
    if (!mount) { say('The music player is missing. Reload the page.'); return; }
    const iframe = document.createElement('iframe');
    iframe.id = config.playerId;
    iframe.title = 'YouTube music player';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    const embed = new URL('https://www.youtube.com/embed/' + (first >= 0 ? items[first].videoId : ''));
    embed.search = new URLSearchParams({ enablejsapi: '1', playsinline: '1', rel: '0', origin: window.location.origin, widget_referrer: window.location.origin }).toString();
    if (first < 0) {
      iframe.hidden = true;
      emptyPlayerNote = document.createElement('div'); emptyPlayerNote.className = 'tc-radio-empty';
      emptyPlayerNote.textContent = 'Choose a song from search or a playlist to start your soundtrack.';
      mount.before(emptyPlayerNote);
    }
    playerFrame = iframe;
    iframe.src = embed.href;
    mount.replaceWith(iframe);
    player = new window.YT.Player(config.playerId, {
      ...(first >= 0 ? { videoId: items[first].videoId } : {}),
      playerVars: { playsinline: 1, rel: 0, enablejsapi: 1, origin: window.location.origin },
      events: {
        onReady: () => { ready = true; root.dispatchEvent(new CustomEvent('triplec:ready')); nextButton.disabled = false; updateButtons(); renderRatings(); if (first >= 0) { remember(current()); say('Press play when you’re ready.'); maybePrefetch(); } else say(config.personal ? 'Choose a liked song or search to start.' : 'Your saved songs are disliked. Tap Skip to find a fresh match.'); },
        onAutoplayBlocked: () => say('Your browser paused automatic playback. Press Play to start the music.'),
        onStateChange: event => {
          root.dispatchEvent(new CustomEvent('triplec:state', {detail:event.data}));
          if (toggleButton) { toggleButton.textContent = event.data === 1 ? 'Pause' : 'Play'; toggleButton.setAttribute('aria-label', event.data === 1 ? 'Pause music' : 'Play music'); }
          if (event.data === window.YT.PlayerState.PLAYING) { errorCount = 0; recordPlaying(); }
          if (event.data === window.YT.PlayerState.ENDED) void advance();
        },
        onError: event => {
          const code = Number(event?.data || 0);
          if (!current()) { say('Choose a song from search or a playlist to start.'); return; }
          if (code === 153) {
            say('YouTube could not identify this player session. Reload once; if it persists, check browser privacy settings. (YouTube error 153)');
            return;
          }
          const bad = current(); if (bad) failed.add(bad.videoId);
          const next = items.findIndex((item, at) => at > index && available(item));
          if (++errorCount >= 5) { say('Several YouTube videos could not play here. Choose another search result and try again.'); return; }
          if (next >= 0) {
            say('That YouTube video cannot be embedded here. Trying the next result…');
            setTimeout(() => void advance(), 300);
            return;
          }
          if (code === 101 || code === 150) say('That uploader does not allow this video to play on other websites. Choose another search result.');
          else say('That YouTube video is unavailable here. Choose another search result. (YouTube error ' + code + ')');
        }
      }
    });
  }
  window.addEventListener('focus', () => {
    if (!feedbackReady || feedbackBusy) return;
    void playWrites.then(fetchFeedback).then(() => {
      revision++;
      items.splice(index + 1, items.length, ...items.slice(index + 1).filter(available));
      if (current() && disliked(current())) { player?.stopVideo(); void advance(); }
    }).catch(() => tell('Preferences could not refresh. Reload to sync other devices.'));
  });
  if (window.YT?.Player) void init();
  else {
    const previous = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => { if (typeof previous === 'function') previous(); void init(); };
    if (!document.querySelector('script[data-triplec-youtube-api]')) {
      const tag = document.createElement('script'); tag.src = 'https://www.youtube.com/iframe_api'; tag.async = true; tag.addEventListener('error', () => say('YouTube could not load. Check your connection or browser settings, then reload.')); tag.dataset.triplecYoutubeApi = '1'; document.head.append(tag);
    }
  }
}

window.TripleCPreviewSoundtrack = startSoundtrack;
